import Vue from "vue";

export default {
    getMonitoringProject: async ({commit}, selectedProject) => {
        if (selectedProject) {
            let config = {
                method: 'get',
                url: Vue.prototype.$env.VUE_APP_API_URL + '/v3-provisioning/project-report-v3',
                headers: {
                    'Content-Type': 'application/json'
                },
                params: {id: selectedProject._id},
            };
            return await Vue.prototype.$http(config)
                .then((response) => {
                    console.log('Get project response: ', response)
                    if (response.status === 200) {
                        //commit('setAllProjects', response.data)
                        commit('setSelectedMonitoringProject', response.data)

                    }
                    return response.data;
                })
                .catch(function (error) {
                    console.log(error);
                });

        } else {
            commit('setSelectedMonitoringProject', null)
        }
    },
    setQueryData: async ({commit}, queryData) => {
        commit('setQueryData', queryData)
    },
    fetchMonitoringData: async ({commit}, projectId) => {
        let config = {
            method: 'get',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v3-provisioning/monitoring-v3',
            headers: {
                'Content-Type': 'application/json'
            },
            params: {projectId: projectId},
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Get assessment response: ', response)
                if (response.status === 200) {
                    commit('setMonitoringData', response.data)
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    getDeleteVideosReport: async ({commit}, payload) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/videos/delete-report',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Get delete videos response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    console.log('Success!!!')
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    deleteVideos: async ({commit}, payload) => {
        let config = {
            method: 'post',
            url: Vue.prototype.$env.VUE_APP_API_URL + '/v1-data-processing/videos/bulk-delete',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload,
        };
        return await Vue.prototype.$http(config)
            .then((response) => {
                console.log('Delete videos response: ', response)
                if (response.data.errorMessage) {
                    return Error(response.data.errorMessage)
                } else if (response.data.type && response.data.type === 'error') {
                    return Error(response.data.message)
                } else if (response.status === 200) {
                    console.log('Success!!!')
                }
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
    }
}

